import { NIGHT_MOBS } from './night-mobs.js';
/**
 * The creatures a dragon's mark changed (ADR 0087): the kin of a region's
 * creature, drawn by recolouring its body (`scripts/recolour-quarry.py`),
 * that a quest sends the player to fight at the mark itself. They live in
 * no den: each player who takes the quest gets their own, stood by the
 * place (`during` of a quest keeper). Their stat blocks are drawn in
 * `mobs.ts` from their kin's; only the ids and names live here.
 */
export const QUARRY_MOB_IDS = ['fox-charred', 'treant-maddened', 'caiman-maddened'];
export const QUARRY_KIN = {
    'fox-charred': { kin: 'fox', name: 'Renard calciné' },
    'treant-maddened': { kin: 'treant', name: 'Sylvain fou' },
    'caiman-maddened': { kin: 'caiman', name: 'Caïman affolé' },
};
const KIN = new Map([
    ...Object.entries(QUARRY_KIN).map(([id, { kin }]) => [id, kin]),
    // A creature of the night (ADR 0093) stands in its sleeper's dens.
    ...Object.entries(NIGHT_MOBS).map(([id, { sleeper }]) => [id, sleeper]),
]);
/**
 * The creature a quarry or a creature of the night is drawn from, or the mob
 * itself: its biome and dens are its kin's.
 */
export function kinOf(mobId) {
    return KIN.get(mobId) ?? mobId;
}
//# sourceMappingURL=quarry-mobs.js.map